module.exports = __webpack_public_path__ + "static/media/moon-lose.e021c2d9.png";